export default __webpack_public_path__ + "static/media/popularService(5).a4da2756.png";